export default __webpack_public_path__ + "static/media/portal.2ee02bcc.jpg";